document.addEventListener("DOMContentLoaded", () => {
    const { DateTime } = luxon;

    class CountdownTimer extends HTMLElement {

        connectedCallback() {

            this.year = this.getAttribute('data-year');
            this.month = this.getAttribute('data-month');
            this.day = this.getAttribute('data-day');

            this.hour = this.getAttribute('data-hour') || 23;
            this.minute = this.getAttribute('data-minute') || 59;

            this.hideTimer =
                this.getAttribute('data-hide-timer') === 'true';

            this.completeMessage =
                this.getAttribute('data-complete-message');

            this.parentEl =
                this.closest('.header_countdown');

            this.display =
                this.querySelector('[data-time-display]');

            this.daysEl =
                this.querySelector('[data-days-placeholder]');

            this.hoursEl =
                this.querySelector('[data-hours-placeholder]');

            this.minutesEl =
                this.querySelector('[data-minutes-placeholder]');

            this.secondsEl =
                this.querySelector('[data-seconds-placeholder]');

            this.messageEl =
                this.querySelector('[data-message-placeholder]');

            if (
                !this.display ||
                !this.daysEl ||
                !this.hoursEl ||
                !this.minutesEl ||
                !this.secondsEl
            ) {
                console.error(
                    'Countdown placeholders are missing.'
                );
                return;
            }

            const now =
                DateTime.now().setZone('America/New_York');

            /*
             * Use merchant date if available
             */
            if (
                this.year &&
                this.month &&
                this.day
            ) {

                const configuredDate =
                    DateTime.fromObject(
                        {
                            year: parseInt(this.year),
                            month: parseInt(this.month),
                            day: parseInt(this.day),
                            hour: parseInt(this.hour),
                            minute: parseInt(this.minute),
                            second: 0
                        },
                        {
                            zone: 'America/New_York'
                        }
                    );

                /*
                 * If merchant date expired,
                 * switch to next Monday
                 */
                if (configuredDate <= now) {
                    this.setNextMonday(now);
                }

            } else {
                /*
                 * No date configured,
                 * use next Monday
                 */
                this.setNextMonday(now);
            }

            this.startTimer();
        }

        /*
         * Automatically calculate next Monday
         */
        setNextMonday(now) {

            let daysUntilMonday =
                8 - now.weekday;

            if (daysUntilMonday <= 0) {
                daysUntilMonday += 7;
            }

            const nextMonday =
                now.plus({
                    days: daysUntilMonday
                });

            this.year =
                nextMonday.year;

            this.month =
                nextMonday.month;

            this.day =
                nextMonday.day;
        }

        setTargetTimestamp() {
            this.targetTimestamp = DateTime.fromObject(
                {
                    year: parseInt(this.year),
                    month: parseInt(this.month),
                    day: parseInt(this.day),
                    hour: parseInt(this.hour),
                    minute: parseInt(this.minute),
                    second: 0
                },
                {
                    zone: 'America/New_York'
                }
            ).toMillis();
        }

        startTimer() {
            this.setTargetTimestamp();
            this.updateTime();

            this.timerInterval = window.setInterval(
                () => this.updateTime(),
                1000
            );
        }

        updateTime() {
            let remaining = this.targetTimestamp - Date.now();

            if (remaining <= 0) {
                const now = DateTime.now().setZone('America/New_York');

                this.setNextMonday(now);
                this.setTargetTimestamp();

                remaining = this.targetTimestamp - Date.now();
            }

            const totalSeconds = Math.max(
                0,
                Math.floor(remaining / 1000)
            );

            const days = Math.floor(totalSeconds / 86400);
            const hours = Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            const daysText = String(days).padStart(2, '0');
            const hoursText = String(hours).padStart(2, '0');
            const minutesText = String(minutes).padStart(2, '0');
            const secondsText = String(seconds).padStart(2, '0');

            if (this.daysEl.textContent !== daysText) {
                this.daysEl.textContent = daysText;
            }

            if (this.hoursEl.textContent !== hoursText) {
                this.hoursEl.textContent = hoursText;
            }

            if (this.minutesEl.textContent !== minutesText) {
                this.minutesEl.textContent = minutesText;
            }

            if (this.secondsEl.textContent !== secondsText) {
                this.secondsEl.textContent = secondsText;
            }
        }
        disconnectedCallback() {
            if (this.timerInterval) {
                window.clearInterval(this.timerInterval);
            }
        }
    }

    if (
        !customElements.get(
            'countdown-timer'
        )
    ) {
        customElements.define(
            'countdown-timer',
            CountdownTimer
        );
    }

    document
        .querySelectorAll(
            '.header_countdown'
        )
        .forEach(el => {
            el.style.display = 'block';
        });
});